import { useState } from "react";
import { AnimeSpinner, CompletedtickIcon, minimizedIcon, minimizeIcon, modalCloseIcon } from "../common/SvgIcons";
import "../styles/_customMinimizablePopupComponent.scss";
import Button from "@/common/ui/Button";

const CustomMinimizablePopup = ({
  isVisible,
  primaryButtonText,
  setIsVisible,
  heading,
  minimizedPopupHeading,
  onClose,
  handleClickPrimaryButton,
  bodyText,
  popupActionLoading = false,
  popUpActionCompleted = false,
  loading = false,
  children,
}: any) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const handleMinimize = () => {
    console.log("Hello-Minimise");
    setIsMinimized(true);
    setIsVisible(false);
  };
  const handleMaximize = () => {
    console.log("Hello");
    setIsMinimized(false);
    setIsVisible(true);
  };
  const handleModalClose = () => {
    onClose();
  };

  return (
    <>
      {isMinimized && (
        <div className=" fixed text-white z-10 minimized-panel" onClick={handleMaximize}>
          <p className="m-0 heading-text">{minimizedPopupHeading}</p>
          {minimizedIcon}
        </div>
      )}

      {isVisible && !isMinimized && (
        <div className="minimizable-popup-container">
          <div className="minimizable-popup-header">
            <div className="minimizable-popup-header-with-status">
              <p className="mb-0 heading-text">{heading}</p>
              {(popupActionLoading || popUpActionCompleted) && (
                <div
                  className={`minimizable-popup-action-indicator ${
                    popupActionLoading ? "minimizable-popup-action-loading-status" : "minimizable-popup-action-completed-status"
                  }`}
                >
                  {popupActionLoading ? <AnimeSpinner /> : CompletedtickIcon}
                  {popupActionLoading && <p className="mb-0 minimizable-popup-action-loading-status-text">Saving...</p>}
                  {popUpActionCompleted && <p className="mb-0 minimizable-popup-action-loading-status-text">Saved</p>}
                </div>
              )}
            </div>
            <div className="minimizable-popup-actions">
              <button onClick={handleMinimize} className="minimizable-popup-minimize-icon">
                {minimizeIcon}
              </button>
              <button onClick={handleModalClose} className="minimizable-popup-close-icon" disabled={loading}>
                {modalCloseIcon}
              </button>
            </div>
          </div>

          <div className="minimizable-popup-body">{children ? children : <p className="body-text">{bodyText}</p>}</div>

          <div className="minimizable-popup-footer">
            <Button variant="outline" size="small" className="" onClick={handleModalClose} disabled={loading}>
              Cancel
            </Button>
            <Button variant="primary" size="small" onClick={handleClickPrimaryButton} isLoading={loading}>
              {primaryButtonText}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomMinimizablePopup;
